<template>
  <v-app>
    <ModalCartaoDesassociado :open="modalCardDissociated" />
    <v-dialog persistent v-if="termsData" v-model="dialog.open" max-width="600px">      
      <v-card class="termos-cartao">
        <v-card-title style="display:block;" class="styled-header">
          <span class="headline" v-html="termsData.title"></span>
        </v-card-title>
        <v-card-text>
          <p v-html="termsData.message"></p>  
          <div id="contrato"><div v-html="contrato"></div></div>
          <a class="btn block" appEvent="true"  appEventCategory="pop-up" appEventLabel="politica de privacidade atualizada" @click="confirm()">{{ termsData.txtCTA }}</a>
          <p v-html="t('NAO_CONCORDO_EXCLUIR_LINK')"></p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import {resolvePromise} from '../helpers/helpers'
import ModalCartaoDesassociado from '@/components/ModalCartaoDesassociado.vue'

import {VDialog,VCard,VCardTitle,VCardText,VApp} from 'vuetify/lib'
import { translate } from '../services/translate.service';
import {myUser, getNewTerms, updateNewTerms} from '../services/user.service'
import { getActiveTermsAndConditions } from '../services/terms.service'
export default {
  name: 'ModalNovosTermos',
  methods: {
    t:translate,
    confirm: function() {
      let data = new FormData();
      data.append('id', this.myUser.id);
      data.append('name', this.myUser.name);
      data.append('lastName', this.myUser.lastName);
      data.append('phone', this.myUser.phone);
      data.append('checktermupdate', (new Date).toISOString());
      updateNewTerms(data)
      .then(r=> {
        this.dialog.open = false;
      }).catch(e => {})
    },
  },
  components: {
      VDialog,
      VCard,
      VCardTitle,
      VCardText,
      VApp,
    ModalCartaoDesassociado
  },
  props: { },
  created() {
    setTimeout(() => {
      getNewTerms().then(t => {
        getActiveTermsAndConditions().then(({ data }) => {
          this.contrato = data.text;
          this.termsData = t.data;
          this.dialog.open = t.data.show;
          resolvePromise(myUser(), (u) =>{
            this.myUser = u.data;
          }, err => {
            if(err == 'CARD-DISSOCIATED') {
              //emitToParent('cardDissociated', this, true);
              this.modalCardDissociated = true;
              this._mount();
            } else {
              resolvePromise(myUser(), (u) =>{
                this.myUser = u.data;
              }, err => {
              })
            }
          });
        });
      });
    },1000);
  },
  data() {
    return {
      contrato: null,
      termsData: null,
      modalCardDissociated:null,
      myUser:null,
      dialog: {
        open: false,
      },
    }
  }
}
</script>

<style lang="scss">
.termos-cartao  { background: #e7e6e6 !important;  }
.termos-cartao .v-card__text {
  justify-content: center;
  display: flex;
  flex-direction: column;
}
.termos-cartao .v-card__text > p {
  font-size: 18px;
  a {
    color: #3D3C3C;
    text-decoration: underline;
  }
}
.termos-cartao #contrato p,
.termos-cartao #contrato span { font-size: 14px !important; }

.termos-cartao #contrato p { margin-bottom: 5px; }
.termos-cartao .v-card__text .btn { min-width: 90%; }
.termos-cartao #contrato {
  background: white;
  width: 100%;
  height: 300px;
  border: 1px solid #c8c8c8;
  padding: 10px;
  overflow: auto;
}
.v-dialog .btn { margin: 20px auto; }
</style>
